<template>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialogConfirm')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialogConfirm"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogConfirm()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="!loadingRes && !contentDialogRes.length" class="tf_text_url" v-html="contentDialogConfirm"></div>
          <div v-else class="tf_loading_url">
            <div class="tf_contentLoading">
              <div v-if="loadingRes" class="text-xs-center">
                <v-progress-circular
                  :rotate="-90"
                  :size="120"
                  :width="8"
                  :value="loadingValue"
                  color="primary"
                >
                  {{ loadingValue }} %
                </v-progress-circular>
              </div>
              <div v-if="contentDialogRes.length" class="tf_contentLoadingTxt">
                <div class="contentLoading" v-html="contentDialogRes"></div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && !modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn v-if="!loadingModifDialog" flat @click="closeDialogConfirm()">{{ $t('no') }}</v-btn>
          <v-btn 
            :loading="loadingModifDialog"
            :disabled="loadingModifDialog"
            color="primary"
            @click="submitDialogConfirm()"
          >{{ $t('yes') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialogConfirm')">{{ $t('close') }}</v-btn>
          <v-btn color="primary" @click="$emit('closeDialogConfirm')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialogConfirm()">{{ $t('close') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>



<script>
export default {
  props: {
    showDialogConfirmation: {
      type: Boolean,
      default: false
    },
    loadingModifDialog: {
      type: Boolean,
      default: false
    },
    loadingRes: {
      type: Boolean,
      default: false
    },
    contentDialogConfirm: {
      type: String,
      default: ''
    },
    contentDialogRes: {
      type: String,
      default: ''
    },
    titleDialogConfirm: {
      type: String,
      default: 'Confirmation'
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    modifBaseCo: {
      type: Boolean,
      default: false
    },
    startLoading: {
      type: Number,
      default: 0
    },
    endLoading: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
    loadingValue () {
      return Math.round((this.startLoading * 100) / this.endLoading)
    }
  },
  mounted () {},
  updated () {},
  methods: {
    closeDialogConfirm () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialogConfirm')
      } else {
        this.$emit('justCloseDialogConfirm')
      }
    },
    submitDialogConfirm () {
      this.$emit('submitDialogConfirm')
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .tf_loading_url {
    max-height: 400px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .tf_text_url {
    max-height: 400px;
    display: flex;
    flex-direction: column;
  }
  .contentLoading {
    padding-top: 20px;
  }
  .v-progress-circular {
    margin: 1rem;
  }
  .v-progress-circular__overlay {
    stroke: currentColor;
    z-index: 2;
    transition: all 0.6s ease-in-out;
  }
  .tf_contentLoading{
    height: 100%;
    width: 100%;
  }
  .tf_contentLoadingTxt {
    height: calc(400px - 132px);
  }
  .contentLoading {
    height: 100%;
  }
  .tf_contentLoading h3 {
    text-align: left;
  }
  .loadingNum {
    text-align: center;
  }
  .tf_contentLoading .listeUrlsError {
    text-align: left;
  }
  .tf_contentLoading .listeUrlsError li {
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogConfirm.vue